<mat-form-field class="autocomplete-field"
  [class.loading-field]="loading"
  [hidden]="disabled">
  <mat-label>{{label}}</mat-label>

  <input type="text" matInput [formControl]="searchCtr" [readonly]="disabled"
    [matAutocomplete]="auto" (blur)="hasError()">

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let item of filteredList | async" [value]="item">
      <div (click)="$event.stopPropagation(); selected(item)">
        <mat-checkbox
          [checked]="isSelected(item)"
          (change)="selected(item)"
          (click)="$event.stopPropagation()">
          {{item.name}}
        </mat-checkbox>
      </div>
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="searchCtr.hasError('required')">
    {{ 'forms.Required' | translate }}
  </mat-error>
</mat-form-field>

<div>
  <ul class="chips-selected">
    <li *ngFor="let item of selectedList; index as index">
      {{item.name}}
      <span class="remove" *ngIf="!disabled" (click)="removeSelected(index)">&times;</span>
    </li>
  </ul>
</div>
